import { Injectable } from '@angular/core';

interface AppConfig {
  azure: {
    tenantId: string;
    clientId: string;
  };
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: AppConfig | null = null;

  async load(): Promise<void> {
    const response = await fetch('assets/config.json');
    this.config = await response.json();
  }

  get azure(): AppConfig['azure'] {
    if (!this.config) {
      throw new Error('ConfigService not initialized. Call load() first.');
    }
    return this.config.azure;
  }
}
